import React from 'react';
export function Footer() {
  return <footer className="bg-[#060B18] border-t border-white/5 py-10" data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-108">
          <div className="flex items-center gap-3" data-id="element-109">
            <span className="font-display font-bold text-lg text-white" data-id="element-110">
              Founder<span className="text-teal" data-id="element-111">Vault</span>
            </span>
            <span className="text-white/20 text-sm" data-id="element-112">© 2026 FounderVault</span>
          </div>

          <div className="flex items-center gap-6 text-sm text-white/30" data-id="element-113">
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-114">
              Privacy
            </a>
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-115">
              Terms
            </a>
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-116">
              Refund Policy
            </a>
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-117">
              Contact
            </a>
          </div>
        </div>

        <p className="text-white/15 text-[10px] text-center mt-6 max-w-lg mx-auto leading-relaxed" data-id="element-118">
          This product is for informational purposes only. FounderVault is not a
          financial advisor. Consult a qualified professional for financial
          advice specific to your situation.
        </p>
      </div>
    </footer>;
}